import { Chip } from '@mui/material'
import React from 'react'

// Values will also be used as part of the dialog title.
export const STATEMENT_TYPE = {
  monthly: 'Monthly',
  pmsDaily: 'PMS Daily',
  daily: 'Daily',
  dailyPeriodic: 'Periodic Daily',
  entry: 'Entry Summary'
}

export const StatusChip = ({ finalized, ...props }) => <Chip
  label={finalized ? 'Finalized' : 'Preliminary'}
  color={finalized ? 'secondary' : 'warning'}
  {...props}
/>

export const StatementTypeChip = ({ type, ...props }) => <Chip
  label={type}
  color={type === STATEMENT_TYPE.daily
    ? 'secondary' : 'primary'}
  {...props}
/>

export * from './ResponseItem'
export * from './columns'
export * from './fields'
export * from './options'